<script>
    import { isLoading } from "../stores.js";
</script>

{#if $isLoading}
    <div class="container">
        <div class="loader" />
    </div>
{/if}

<style>
    .container {
        grid-row: 1/-1;
        grid-column: 1/-1;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.8);
        z-index: 100000;
    }

    .loader {
        border: 10px solid #f3f3f3;
        border-top: 10px solid #000;
        border-radius: 50%;
        width: 100px;
        height: 100px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
